import {
  GURUS_GET,
  GURU_JENJANGS_GET,
  GURU_ADD,
  GURU_EDIT,
  GURU_GET,
  GURU_DELETE,
} from './reduxConstant';

export const gurusGet = (gurus) => {
  return {
    type: GURUS_GET,
    payload: {
      gurus,
    },
  };
};

export const guruJenjangsGet = (jenjangs) => {
  return {
    type: GURU_JENJANGS_GET,
    payload: {
      jenjangs,
    },
  };
};

export const guruAdd = (guru) => {
  return {
    type: GURU_ADD,
    payload: {
      guru,
    },
  };
};

export const guruEdit = (guru) => {
  return {
    type: GURU_EDIT,
    payload: {
      guru,
    },
  };
};

export const guruGet = (guru) => {
  return {
    type: GURU_GET,
    payload: {
      guru,
    },
  };
};

export const guruDelete = (guru) => {
  return {
    type: GURU_DELETE,
    payload: {
      guru,
    },
  };
};
